import { render, staticRenderFns } from "./orderPrint.vue?vue&type=template&id=8bb48150&scoped=true&"
import script from "./orderPrint.vue?vue&type=script&lang=js&"
export * from "./orderPrint.vue?vue&type=script&lang=js&"
import style0 from "./orderPrint.vue?vue&type=style&index=0&id=8bb48150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb48150",
  null
  
)

export default component.exports